import { BladeDamagesRepository } from "@/api/Repositories";
import { RepairStagesRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    list: [],
    files: []
  },
  mutations: {
    list (state, data) {
      state.list = []
      state.list = data
    },
    files (state, data) {
      state.files = []
      state.files = data
    },
  },
  actions: {
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        BladeDamagesRepository.get(obj)
          .then(response => {
            const data = response.data.data.repair_stages
            commit('list', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    create (context, data) {
      return new Promise((resolve, reject) => {
        RepairStagesRepository.create(data)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    edit (context, data) {      
      return new Promise((resolve, reject) => {
        RepairStagesRepository.update(data)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    delete (context, id) {
      return new Promise((resolve, reject) => {
        RepairStagesRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    },
    getInterventionFiles (context, obj) {
      return new Promise((resolve, reject) => {
        RepairStagesRepository.getInterventionFiles(obj)
          .then(response => {
            resolve(response);
          }).catch(error => {
            reject(error);
          });
      });
    },
    getFiles ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        RepairStagesRepository.getFiles(obj)
          .then(response => {
            const data = response.data.data.repair_stage_images
            commit('files', data)
            resolve();
          }).catch(error => {
            reject(error);
          });
      });
    },
    uploadFile (context, obj) {
      const formData = new FormData();
      formData.append('repair_stage_image', obj.fileToUpload)
      obj.file = formData

      return new Promise((resolve, reject) => {
        RepairStagesRepository.uploadFile(obj)
          .then(() => {
            resolve();
          }).catch(errorDeleteFile => {
            reject(errorDeleteFile);
          });
      });
    },
    deleteFile (context, obj) {
      return new Promise((resolve, reject) => {
        RepairStagesRepository.deleteFile(obj)
          .then(() => {
            resolve();
          }).catch(errorDeleteFile => {
            reject(errorDeleteFile);
          });
      });
    },
  }
}
